import { PubSub } from '@/shared/lib/pub-sub';
import type { Locale } from './types';

export const LOCALE_EVENTS = {
  INITIALIZED: 'INITIALIZED',
} as const;

/**
 * PubSub broker for locale lifecycle events. Services that need to wait for
 * the initial locale resolution (e.g. `Session` before creating a session)
 * subscribe here via `.ever(INITIALIZED, callback)`.
 */
export class LocaleEvents extends PubSub {
  EVENTS = LOCALE_EVENTS;

  emitInitialized(locale: Locale): void {
    this.trigger(LOCALE_EVENTS.INITIALIZED, locale, true);
  }
}

export const localeEvents = new LocaleEvents();
